module.exports = __webpack_public_path__ + "media/images/destroy-650cdc57dc0be3a71cc230a760215df5.svg";